// Contact.js
import React, { useRef } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Contact.css';
import emailjs from 'emailjs-com';

function Contact() {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_xjzs4c8',
        'template_l2h2vwk', // replace with your actual template ID
        formRef.current,
        'QYSoXTSzv9lsKSKAm' // your public API key
      )
      .then(
        (result) => {
          console.log('✅ Message sent:', result.text);
          alert('Your message has been sent!');
          formRef.current.reset();
        },
        (error) => {
          console.error('❌ Failed to send message:', error.text);
          alert('There was an error sending your message.');
        }
      );
  };

  return (
    <>
      <Navbar />
      <div className='gap'></div>
      <section className="contact-banner">
        <h2>Contact Us</h2>
        <p className="breadcrumb">Home → Contact Us</p>
      </section>

      <section className="contact-info">
        <div className="info-cards">
          <div className="info-card">
            <div className="info-icon"><i className="fa-solid fa-location-dot"></i></div>
            <div>
              <h5>Our Primary Address</h5>
              <p>708, Shubham Avenue, Pant Nagar, Ghatkopar (E), Mumbai - 400075</p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-icon"><i className="fa-solid fa-phone"></i></div>
            <div>
              <h5>Phone Number</h5>
              <p>+91 97737 49023</p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-icon"><i className="fa-solid fa-envelope"></i></div>
            <div>
              <h5>Email Address</h5>
              <p>khyati@sonalholidays.com</p>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-main">
        <div className="form-card">
          <h3>Plan Your Trip</h3>
          <form ref={formRef} onSubmit={sendEmail}>
            <div className="input-group">
              <input type="text" name="name" placeholder="First Name" required />
              <i className="fa-regular fa-user"></i>
            </div>
            <div className="input-group">
              <input type="email" name="email" placeholder="Your Mail" required />
              <i className="fa-regular fa-envelope"></i>
            </div>
            <div className="input-group">
              <select name="title" required>
                <option value="">Select Tour Type</option>
                <option value="Domestic">Domestic</option>
                <option value="International">International</option>
              </select>
              <i className="fa-solid fa-chevron-down"></i>
            </div>
            <div className="input-group">
              <textarea name="message" placeholder="Your Message" required></textarea>
              <i className="fa-regular fa-message"></i>
            </div>
            <button className="send-button" type="submit">
              Send message <i className="fa-regular fa-paper-plane"></i>
            </button>
          </form>
        </div>

        <div className="contact-map">
          <iframe
            title="Sonal Holidays Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.5401239602725!2d72.90999027630716!3d19.083946682122306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c79f6a72af6b%3A0x5c1e2a5cccf2a4ef!2sShubham%20Avenue!5e0!3m2!1sen!2sin!4v1751018891782!5m2!1sen!2sin"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{ border: 0, borderRadius: "12px" }}
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Contact;
